<button (click)="LoginToOAuthProvider()" value="Login">Login</button>

<fgbcl-errors></fgbcl-errors>

<ng-container *ngIf="customer.ExternalRefNumber">
  <div>
    <p>Account Number {{ customer.ExternalRefNumber }}</p>
    <p>Email Address {{ customer.EmailAddress }}</p>
  </div>
</ng-container>

<fgb-registration-navigation
  (nextButtonClicked)="submitStep()"
  [stepType]="stepType"
  [nextButtonDisabled]="!hasAccountDetails"
></fgb-registration-navigation>
